import { ExternalLink } from "lucide-react";
import { BRAND } from "@/lib/api";

export const Logo = ({ testId = "brand-logo-link", size = "h-12", tagline = true, siteLink = false }) => (
  <div className="inline-flex flex-col items-end gap-1">
    <a href={BRAND.mainSite} data-testid={testId} title="FLS main website" className="group inline-flex flex-col items-end gap-1 self-start">
      <img src="/brand/logo-on-dark.webp" alt="Focused Laser Systems" className={`${size} w-auto transition-opacity group-hover:opacity-90`} />
      {tagline && <span className="-mr-[0.35em] font-mono text-[10px] uppercase tracking-[0.35em] text-slate-400">Support Centre</span>}
    </a>
    {siteLink && (
      <a href={BRAND.mainSite} data-testid={`${testId}-site`} className="inline-flex items-center gap-1 font-mono text-xs font-medium uppercase tracking-[0.18em] text-white antialiased transition-colors hover:text-rose-300">
        <ExternalLink className="h-3 w-3" /> FLS main website
      </a>
    )}
  </div>
);
